<template>
  <div v-if="show" class="fixed inset-0 z-50 flex items-center justify-center p-4 bg-slate-900/50 backdrop-blur-sm animate-fade-in">

    <div class="bg-white dark:bg-slate-900 w-full max-w-lg rounded-2xl shadow-2xl border border-slate-200 dark:border-slate-800 overflow-hidden flex flex-col max-h-[90vh]">

      <div class="px-6 py-4 border-b border-slate-100 dark:border-slate-800 flex justify-between items-center bg-slate-50/50 dark:bg-slate-800/30">
        <div>
          <h2 class="text-lg font-bold text-slate-900 dark:text-white">
            {{ form.id ? 'Editar Proveedor' : 'Nuevo Proveedor' }}
          </h2>
          <p class="text-xs text-slate-500">Gestión de socios comerciales.</p>
        </div>
        <button @click="$emit('close')" class="p-2 hover:bg-slate-200 dark:hover:bg-slate-700 rounded-full transition-colors text-slate-500">
          <X class="w-5 h-5" />
        </button>
      </div>

      <div class="p-6 overflow-y-auto custom-scrollbar space-y-5">

        <form @submit.prevent="handleSubmit" id="supplierForm" class="space-y-5">

          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div class="col-span-1 sm:col-span-2">
              <label class="text-xs font-semibold text-slate-500 uppercase mb-1 block">Razón Social / Nombre</label>
              <div class="relative">
                <Building class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                <input
                  v-model="form.name"
                  type="text"
                  required
                  class="form-input-premium pl-10"
                  placeholder="Ej: Droguería Universal S.A."
                  autofocus
                />
              </div>
            </div>

            <div>
              <label class="text-xs font-semibold text-slate-500 uppercase mb-1 block">NIT / DUI / RUC</label>
              <div class="relative">
                <FileText class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                <input
                  v-model="form.nit_dui"
                  type="text"
                  class="form-input-premium pl-10"
                  placeholder="ID Fiscal"
                />
              </div>
            </div>

            <div>
              <label class="text-xs font-semibold text-slate-500 uppercase mb-1 block">Teléfono</label>
              <div class="relative">
                <Phone class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                <input
                  v-model="form.phone"
                  type="tel"
                  class="form-input-premium pl-10"
                  placeholder="+505 2222-0000"
                />
              </div>
            </div>
          </div>

          <div class="border-t border-slate-100 dark:border-slate-800 my-2"></div>

          <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div class="col-span-1 sm:col-span-2">
              <label class="text-xs font-semibold text-slate-500 uppercase mb-1 block">Nombre del Vendedor</label>
              <div class="relative">
                <User class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                <input
                  v-model="form.contact_name"
                  type="text"
                  class="form-input-premium pl-10"
                  placeholder="Ej: Roberto Sánchez"
                />
              </div>
            </div>

            <div class="col-span-1 sm:col-span-2">
              <label class="text-xs font-semibold text-slate-500 uppercase mb-1 block">Correo Electrónico</label>
              <div class="relative">
                <Mail class="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
                <input
                  v-model="form.email"
                  type="email"
                  class="form-input-premium pl-10"
                  placeholder="ventas@proveedor.com"
                />
              </div>
            </div>
          </div>

          <div>
            <label class="text-xs font-semibold text-slate-500 uppercase mb-1 block">Dirección Física</label>
            <div class="relative">
              <MapPin class="absolute left-3 top-3 w-4 h-4 text-slate-400" />
              <textarea
                v-model="form.address"
                rows="2"
                class="form-input-premium pl-10 resize-none"
                placeholder="Dirección de bodegas o facturación..."
              ></textarea>
            </div>
          </div>

          <div class="flex justify-end pt-2">
            <label class="flex items-center gap-2 cursor-pointer select-none">
              <span class="text-sm font-medium text-slate-700 dark:text-slate-300">
                {{ form.is_active ? 'Proveedor Activo' : 'Proveedor Inactivo' }}
              </span>
              <div class="relative">
                <input type="checkbox" v-model="form.is_active" class="sr-only peer">
                <div class="w-11 h-6 bg-slate-200 peer-focus:outline-none rounded-full peer dark:bg-slate-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-emerald-500"></div>
              </div>
            </label>
          </div>

        </form>
      </div>

      <div class="px-6 py-4 bg-slate-50 dark:bg-slate-800/50 border-t border-slate-100 dark:border-slate-800 flex justify-end gap-3">
        <button
          type="button"
          @click="$emit('close')"
          class="px-4 py-2 text-sm font-medium text-slate-700 bg-white border border-slate-300 rounded-xl hover:bg-slate-50 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-600 dark:hover:bg-slate-700 transition-colors"
        >
          Cancelar
        </button>
        <button
          type="submit"
          form="supplierForm"
          :disabled="isSaving"
          class="px-6 py-2 text-sm font-bold text-white bg-brand-600 rounded-xl hover:bg-brand-700 shadow-lg shadow-brand-500/30 transition-all flex items-center gap-2 disabled:opacity-70"
        >
          <Loader2 v-if="isSaving" class="w-4 h-4 animate-spin" />
          <Save v-else class="w-4 h-4" />
          Guardar
        </button>
      </div>

    </div>
  </div>
</template>

<script setup>
import { reactive, ref, watch } from 'vue';
import {
  X, Save, Loader2, Building, FileText, Phone, User, Mail, MapPin
} from 'lucide-vue-next';
import apiClient from '@/api/client';
import { SecureStorage } from '@/utils/secureStorage';
import { useToast } from '@/composables/useToast';

const props = defineProps({
  show: Boolean,
  supplierToEdit: Object
});

const emit = defineEmits(['close', 'saved']);
const { showSuccess, showError, showWarning } = useToast();

const isSaving = ref(false);
const currentUser = SecureStorage.getItem('llevo_user');
const currentCompanyId = currentUser?.company;

const form = reactive({
  id: null,
  company: currentCompanyId,
  name: '',
  nit_dui: '', // <--- CAMBIADO
  contact_name: '',
  phone: '',
  email: '',
  address: '',
  is_active: true
});

watch(() => props.supplierToEdit, (newVal) => {
  if (newVal) {
    Object.assign(form, {
      id: newVal.id,
      company: newVal.company || currentCompanyId,
      name: newVal.name,
      nit_dui: newVal.nit_dui, // <--- CAMBIADO
      contact_name: newVal.contact_name,
      phone: newVal.phone,
      email: newVal.email,
      address: newVal.address,
      is_active: Boolean(newVal.is_active)
    });
  } else {
    // Reset
    Object.assign(form, {
      id: null,
      company: currentCompanyId,
      name: '',
      nit_dui: '', // <--- CAMBIADO
      contact_name: '',
      phone: '',
      email: '',
      address: '',
      is_active: true
    });
  }
});

const handleSubmit = async () => {
  if (!form.name.trim()) {
    showWarning('El nombre del proveedor es obligatorio.');
    return;
  }

  isSaving.value = true;
  try {
    const payload = { ...form };

    if (form.id) {
      await apiClient.put(`/suppliers/${form.id}`, payload);
      showSuccess('Proveedor actualizado.');
    } else {
      await apiClient.post('/suppliers', payload);
      showSuccess('Proveedor registrado.');
    }
    emit('saved');
    emit('close');
  } catch (error) {
    console.error(error);
    showError('Error al guardar el proveedor.');
  } finally {
    isSaving.value = false;
  }
};
</script>

<style scoped>
@keyframes fade-in {
  from { opacity: 0; transform: scale(0.95); }
  to { opacity: 1; transform: scale(1); }
}
.animate-fade-in {
  animation: fade-in 0.2s ease-out forwards;
}
</style>